import { FC, useCallback, useMemo } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useDoResetPasswordSendCode } from './hook/useDoResetPasswordSendCode';
import { UserType } from '../../../../../types';
import { FormInner } from '@/bo-kit/components/ResetPasswordPage/components/ResetPassword/ResetPasswordForm/components/FormInner';
import { SendCodeRequest } from '../../../../../transport/types/SendCodeRequest';

export const ResetPasswordForm: FC = () => {
    const { t: validationT } = useTranslation('bo-kit__validation');

    const validationSchema = useMemo(
        () =>
            Yup.object().shape({
                email: Yup.string()
                    .email(validationT('Invalid email format'))
                    .required(validationT('Field is required')),
            }),
        [validationT]
    );
    const { doSendCode, isLoading, isSuccess, isError, errorMessage, roles, reset } =
        useDoResetPasswordSendCode();

    const onSubmit = useCallback(
        (form: SendCodeRequest, userType?: UserType) => {
            if (userType !== undefined) {
                doSendCode({ userType, email: form.email });
            } else {
                doSendCode(form);
            }
        },
        [doSendCode]
    );

    const onFormSubmit = useCallback((data: SendCodeRequest) => onSubmit(data), [onSubmit]);

    return (
        <Formik<SendCodeRequest>
            initialValues={{ email: '', userType: undefined }}
            onSubmit={onFormSubmit}
            validationSchema={validationSchema}
        >
            {(formik) => (
                <FormInner
                    cancelRoleChoose={reset}
                    roles={roles}
                    formik={formik}
                    isLoading={isLoading}
                    isSuccess={isSuccess}
                    isError={isError}
                    errorMessage={errorMessage}
                />
            )}
        </Formik>
    );
};
